import React from 'react'

import { Container, Row, Col } from 'reactstrap'

import { EmailsApi } from 'typescript-axios'
import ContactForm from '../components/ContactForm'

import data from '../data/contact.json'
import { translate } from '../translations/utils'
import withLocale from '../hocs/WithLocale'
import useTranslation from '../hooks/UseTranslation'
import { getAxiosParams } from '../utils/client'

const EMAILS_SERVICE = new EmailsApi(getAxiosParams())

export async function getStaticProps(ctx) {
  const { locale, defaultLocale } = ctx
  return {
    props: {
      nav: {
        light: true,
        classes: 'shadow',
        color: 'white'
      },
      title: translate('contact_page_title', locale, defaultLocale),
      locale,
      defaultLocale
    }
  }
}

const Page = () => {
  const { t } = useTranslation()
  return (
    <>
      <section className='hero py-6 py-lg-7 text-white dark-overlay'>
        {data.img && (
          <img
            src='/content/img/yoga-bg-main.jpg'
            className='bg-image'
            alt={data.title}
          />
        )}
        <Container className='overlay-content'>
          <h1 className='hero-heading'>{t('contact_hero_title')}</h1>
        </Container>
      </section>
      <section className='py-6'>
        <Container>
          <Row>
            <Col md='4' className='text-center text-md-left mb-4 mb-md-0' />
            <Col md='4' className='text-center text-md-left mb-4 mb-md-0'>
              <div className='icon-rounded mb-4 bg-primary-light'>
                <svg className='svg-icon w-2rem h-2rem text-primary'>
                  <use xlinkHref='content/svg/orion-svg-sprite.svg#paper-plane-1' />
                </svg>
              </div>
              <h3 className='h5'>{t('contact_electronicsupport_title')}</h3>
              <p
                className='text-muted'
                dangerouslySetInnerHTML={{
                  __html: t('contact_electronicsupport_content')
                }}
              />
              {/* <ul className="list-unstyled text-muted">
                                <li key="contact_electronicsupport_email">{t("contact_electronicsupport_email")}</li>
                            </ul> */}
            </Col>
            <Col md='4' className='text-center text-md-left mb-4 mb-md-0' />
          </Row>
        </Container>
      </section>
      <section className='py-6 bg-gray-100'>
        <Container>
          <h2 className='h4 mb-5'>{t('contact_form_title')}</h2>
          <Row>
            <Col md='7' className='mb-5 mb-md-0'>
              <ContactForm />
            </Col>
            <Col md='5'>
              <div className='pl-lg-4'>
                <div
                  dangerouslySetInnerHTML={{ __html: t('contact_content') }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default withLocale(Page)
